import React from 'react'
import { IconClipboardList, IconListCheck, IconScale, IconSparkles } from '@tabler/icons-react'

export const COACHING_TASK_TYPE = 'coaching'
export const COMPLIANCE_TASK_TYPE = 'compliance'
export const QA_DISPUTE_TASK_TYPE = 'qa_dispute'
export const QA_MANUAL_SCORE_TASK_TYPE = 'qa_manual_score'
export const PROMPT_FEEDBACK_TASK_TYPE = 'prompt_feedback'

export const READY_FOR_REVIEW = 'ready_for_review'
export const COLLECTING_EVIDENCE = 'collecting_evidence'
export const IN_PROGRESS = 'in_progress'
export const COMPLETED = 'completed'
export const EXPIRED = 'expired'
export const IGNORED = 'ignored'
export const INBOX = 'inbox'

export const INBOX_PAGE_LIMIT = 25
export const INBOX_DEBOUNCE_MS = 300
export const INBOX_DEFAULT_DATE_RANGE_DAYS = 60

// Coaching tasks predating named titles have a null name.
export const DEFAULT_COACHING_TITLE = 'Coaching Feedback'

export const COACHING_INBOX = 'coaching_inbox'
export const COMPLIANCE_INBOX = 'compliance_inbox'
export const QA_INBOX = 'qa_inbox'
export const PROMPT_ENGINEER_INBOX = 'prompt_engineer_inbox'

export const INBOX_TYPE_MAP = {
  [COACHING_INBOX]: 'coaching',
  [COMPLIANCE_INBOX]: 'compliance',
  [QA_INBOX]: 'quality',
}

export const TASK_TYPE_MAP = {
  [COACHING_INBOX]: [COACHING_TASK_TYPE],
  [COMPLIANCE_INBOX]: [COMPLIANCE_TASK_TYPE],
  [QA_INBOX]: [QA_DISPUTE_TASK_TYPE, QA_MANUAL_SCORE_TASK_TYPE],
  [PROMPT_ENGINEER_INBOX]: [PROMPT_FEEDBACK_TASK_TYPE],
}

export const TASK_STATUS_MAP = {
  [READY_FOR_REVIEW]: 'Ready for Review',
  [COLLECTING_EVIDENCE]: 'Collecting Reports',
  [IN_PROGRESS]: 'In Progress',
  [COMPLETED]: 'Reviewed',
  [EXPIRED]: 'Expired',
  [IGNORED]: 'Dismissed',
}

export const ONBOARDING = {
  [COACHING_INBOX]: {
    icon: <IconClipboardList />,
    title: 'Streamline Coaching with AI-Powered Sessions',
    description:
      'Coach agents faster. Balto Coaching uses AI to surface coachable calls and organizes them in one simple coaching inbox.',
  },
  [COMPLIANCE_INBOX]: {
    icon: <IconScale />,
    title: 'Stay Compliant with AI-Generated Exception Tasks',
    description:
      "Balto helps you maintain compliance by automatically generating exception tasks based on your company's policies—so you can review and take action with ease.",
  },
  [QA_INBOX]: {
    icon: <IconListCheck />,
    title: 'Streamline QA with Smarter Workflows',
    description:
      'Balto makes QA faster by pulling key insights from calls into actionable tasks, so you can review, assess, and resolve quality issues efficiently.',
  },
  [PROMPT_ENGINEER_INBOX]: {
    icon: <IconSparkles />,
    title: 'Review Prompt Feedback',
    description:
      'Review reports where AI prompts produced incorrect results. Use feedback to improve prompt accuracy and performance.',
  },
}

export const COACHING_QUESTIONS = {
  sales: [
    'Did the agent clearly and concisely articulate the value proposition of their solution?',
    "Did the agent clearly attempt to earn the customer's business?",
    "Did the agent uncover the customer's concerns?",
    'Did the agent ask at least two discovery questions?',
    'Why are customers not moving forward with setting an appointment?',
  ],
  customer_service: [
    "Did the agent reduce the customer's frustration?",
    'Did the agent express empathy for any difficulties the customer is encountering?',
    "Did the agent ask follow-up questions to better understand the customer's issue?",
    'Show me {channel} where the customer wants to cancel',
  ],
  collections: [
    'Did the collector ask for payment in full?',
    "Did the collector ask questions to understand the consumers' income streams and where they might have funds available to pay their balance?",
    'Did the collector recap the arrangement for the consumer at the end of the interaction?',
  ],
}

export const LOADING_PHRASES = [
  'Finding {channel} that match your coaching focus...',
  'Analyzing for areas of improvement...',
  'Generating AI recommendations...',
  'Almost there, just a few more seconds...',
]
